import { Handle, Position, type NodeProps } from '@xyflow/react';
import { observer } from 'mobx-react-lite';

import { Group, Stack } from '@mantine/core';
import { Text, Title } from '@repo/foundations';
import { EntityIcon } from '../EntityIcon/EntityIcon';
import { useStyles as useEntityNodeStyles } from '../EntityNode/EntityNode.styles';
import { useStyles as useEntityNodeHeaderStyles } from '../EntityNodeHeader/EntityNodeHeader.styles';
import type { ERDFlowNode } from './TableNode.types';
import TableNodeColumns from './TableNodeColumns';

const TableNode = observer(({ data, selected }: NodeProps<ERDFlowNode>) => {
	const { columns_with_relationships, columns_without_relationships } = data;

	const { classes: entityNodeClasses } = useEntityNodeStyles({
		selected: Boolean(selected),
	});
	const { classes: entityNodeHeaderClasses } = useEntityNodeHeaderStyles();

	return (
		<Group className={entityNodeClasses.wrapper}>
			<Stack className={entityNodeClasses.content}>
				<Handle
					id="MAIN_TARGET"
					className={entityNodeClasses.handle}
					type="target"
					position={Position.Left}
					isConnectable={false}
				/>
				<Group className={entityNodeHeaderClasses.wrapper}>
					<EntityIcon
						entityType={data.entity_type}
						integrationType={data.integration_type ?? undefined}
					/>
					<Group className={entityNodeHeaderClasses.content}>
						<Stack className={entityNodeHeaderClasses.text}>
							<Title size="sm" truncate>
								{data.title}
							</Title>
							<Text size="xs" color="text/secondary/default">
								{data.subtitle}
							</Text>
						</Stack>
					</Group>
				</Group>
				<TableNodeColumns
					columnsWithRelationships={columns_with_relationships}
					columnsWithoutRelationships={columns_without_relationships}
				/>
				<Handle
					id="MAIN_SOURCE"
					className={entityNodeClasses.handle}
					type="source"
					position={Position.Right}
					isConnectable={false}
				/>
			</Stack>
		</Group>
	);
});

export default TableNode;
